var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path25, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path26, _path27, _g18, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g19, _path36, _path37, _g20, _g21, _g22, _g23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookiesModalCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_8237",
    "data-name": "Groupe 8237",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.797,
    height: 133.582,
    viewBox: "0 0 138.797 133.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2025",
    "data-name": "Rectangle 2025",
    width: 138.797,
    height: 133.582,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2002",
    "data-name": "Rectangle 2002",
    width: 3.849,
    height: 8.092,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    "data-name": "Rectangle 2003",
    width: 2.398,
    height: 4.907,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 4.873,
    height: 5.572,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 1.756,
    height: 2.365,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 4.961,
    height: 3.005,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    width: 4.675,
    height: 3.789,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 3.6,
    height: 5.459,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    width: 1.381,
    height: 1.759,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    width: 2.021,
    height: 1.088,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    width: 5.396,
    height: 6.514,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    width: 2.275,
    height: 11.374,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    width: 6.652,
    height: 6.064,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    width: 9.516,
    height: 14.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2015",
    "data-name": "Rectangle 2015",
    width: 10.073,
    height: 1.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    width: 5.229,
    height: 15.039,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    width: 4.468,
    height: 1.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    width: 14.728,
    height: 34.102,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    width: 2.584,
    height: 5.349,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    width: 1.703,
    height: 4.363,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32090",
    "data-name": "Trac\\xE9 32090",
    d: "M118.323,159.079c-.14,0-.28,0-.421.006l-.266,0A38.73,38.73,0,0,0,88.644,172.7c-.9,1.026-1.808,2.052-2.7,3.086-10.352,11.881-13.765,29.482-6.724,44.042a44.067,44.067,0,0,1,1.632,4.151c1.67,5.009,2.4,10.459,5.013,15.157a41.235,41.235,0,0,0,12.759,12.581,45.567,45.567,0,0,0,19.2,5.456,50.768,50.768,0,0,0,11.111-.42c.2-.03.415-.069.622-.114a4.008,4.008,0,0,0,.951-.291c.061-.026.121-.054.177-.084l.053-.03c.048-.026.094-.053.138-.081s.111-.069.166-.107a1.684,1.684,0,0,0,1.7-.578l.022-.027a5.687,5.687,0,0,0,.826-2.277,18.882,18.882,0,0,1,1-3.682c.957-2.354,2.594-4.133,2.426-6.8a17.675,17.675,0,0,1,6.8-15.781c1.523-1.345,1.6-3.1,1.937-4.945a19.7,19.7,0,0,1,1.461-3.89c1.917-4.778,3.572-4.193,8.063-4.857a6.144,6.144,0,0,0,2.216-.831c1.213-.764,2.1-2.077,3.26-3.013,2.291-1.926,4.655-2.073,7.5-2.211a3.136,3.136,0,0,0,3.248-3.381,4.362,4.362,0,0,0,.078-1.866,12.4,12.4,0,0,0-.249-2.116,47.612,47.612,0,0,0-2.3-9.42,33.032,33.032,0,0,0-2.415-5.723,17.748,17.748,0,0,0-2.057-3.217c-.331-.4-.686-.783-1.054-1.156-.437-.48-.9-.955-1.394-1.429a28.921,28.921,0,0,0-3.573-2.9c-.373-.326-.741-.658-1.1-1q-1.118-1.051-2.267-2.034a48.581,48.581,0,0,1-4.4-6.313c-2.186-3.485-9.244-7.014-30.328-7.475-.686-.026-1.374-.044-2.067-.046Z",
    transform: "translate(-75.517 -159.079)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    width: 128.472,
    height: 77.017,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32096",
    "data-name": "Trac\\xE9 32096",
    d: "M153.135,26.452c-4.272,3-4.591,7.355-7.97,8.068-3.24.683-4.457-3.006-9.656-5.372-5.438-2.474-13.3-2.625-17.6,1.651-2.462,2.451-2.683,5.293-4.161,15.167-.79,5.278-1.984,12.861-3.652,22.13,25.392,13.1,63.805,8.616,71.632.556C180.1,57.39,172.53,23.8,163.637,24.389a19.7,19.7,0,0,0-2.8-.21,13.168,13.168,0,0,0-7.7,2.273",
    transform: "translate(-110.097 -24.179)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8236",
    "data-name": "Groupe 8236",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8224",
    "data-name": "Groupe 8224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8223",
    "data-name": "Groupe 8223",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32033",
    "data-name": "Trac\\xE9 32033",
    d: "M293.676,396.912a5.677,5.677,0,0,0,.826-2.277,18.875,18.875,0,0,1,1-3.682c.957-2.354,2.593-4.134,2.426-6.8a17.676,17.676,0,0,1,6.8-15.781c1.523-1.345,1.6-3.1,1.937-4.945a19.688,19.688,0,0,1,1.462-3.89c1.917-4.777,3.572-4.194,8.063-4.857a6.144,6.144,0,0,0,2.216-.83c1.213-.764,2.1-2.077,3.26-3.013,2.291-1.926,4.655-2.073,7.5-2.212,2.885-.156,4.173-2.833,2.557-5.228a6.546,6.546,0,0,0-4.809-2.352c-5.184-.479-10.039,1.954-14.924,3.773-3.577,1.382-7.391,2.235-10.711,4.185-10.492,6.7-17.341,19.924-18.736,32.119a14.386,14.386,0,0,0,4.279,12.453c1.377,1.363,4.967,5.54,6.834,3.36Z",
    transform: "translate(-219.642 -265.194)",
    fill: "#b06d31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32034",
    "data-name": "Trac\\xE9 32034",
    d: "M118.916,159.078c15.082.055,28.172,5.624,39.067,15.868,2.329,2.234,5.114,4.065,7.118,6.485,3.53,4.167,7.281,16.074,6.9,21.447-.377,1.281-1.955,1.161-3.057,1.293a11.222,11.222,0,0,0-7.911,4.233c-1.058,1.485-2.007,2.915-4.041,2.868-1.8-.03-3.717-.288-5.475.264-3.872,1.088-5.509,5.038-5.688,8.882-.07,1.3-.283,2.619-1.552,3.178a19,19,0,0,0-2.508,1.155c-2.408,1.652-3.592,4.54-4.589,7.191-1.026,2.806-1.939,5.935-1.365,8.842a7.865,7.865,0,0,1,.237,2.8,7.769,7.769,0,0,1-1.351,2.766,12.619,12.619,0,0,0-1.234,2.621,15.376,15.376,0,0,0-.655,2.748c-.292,1.9.041,3.98-1.929,4.689a6.913,6.913,0,0,1-1.4.338,50.731,50.731,0,0,1-13.437.2c-12.942-1.428-23.483-7.768-29.672-18.39-2.223-4.231-3.01-9.094-4.39-13.641-3.2-8.831-6.553-15.1-5.6-24.96a45.949,45.949,0,0,1,13.1-27.268,38.177,38.177,0,0,1,29.389-13.61Z",
    transform: "translate(-59.279 -123.718)",
    fill: "#fb9f3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32035",
    "data-name": "Trac\\xE9 32035",
    d: "M157.211,475.434c.423-1.634.088-3.479-1.487-4.285-1.11-.614-3.319-.822-3.66.762-.167,1.09.716,2.612,1.191,3.728,1.426,3.356,3.107,3.451,3.945-.158Z",
    transform: "translate(-118.247 -366.068)",
    fill: "#b06d31"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32036",
    "data-name": "Trac\\xE9 32036",
    d: "M150.683,339.594a27.874,27.874,0,0,0,.763-4.757c.112-1.27.142-2.812-.632-3.8-.973-1.273-2.88-1.48-4.4-1.157a6.3,6.3,0,0,0-4.183,3.246c-.578,1.691.369,3.476.807,5.11a42.659,42.659,0,0,0,1.364,4.2c.485,1.153,1.479,2.561,2.89,2.225,1.943-.586,2.837-3.193,3.381-5.02Z",
    transform: "translate(-110.473 -256.45)",
    fill: "#b06d31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32037",
    "data-name": "Trac\\xE9 32037",
    d: "M248.43,390.8c1.045-1,1.832-2.789.887-4.1a6.1,6.1,0,0,0-2.125-1.575c-.9-.425-2.5-1.49-3.434-.874-.893.928.882,2.825,1.23,3.819.477.942.8,2.442,1.566,3.047a1.38,1.38,0,0,0,1.843-.284Z",
    transform: "translate(-189.382 -298.694)",
    fill: "#b06d31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32038",
    "data-name": "Trac\\xE9 32038",
    d: "M188.209,244.4c-.361-1.357-2.44-2.939-3.467-1.4-.843,1.75.305,5.007.841,6.873.3.773.714,2.177,1.672,2.217.743-.094.974-1.619,1.051-2.388a14.177,14.177,0,0,0-.082-5.262Z",
    transform: "translate(-143.445 -188.495)",
    fill: "#b06d31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32039",
    "data-name": "Trac\\xE9 32039",
    d: "M277.145,497.5c.592-2.892-1.612-5.3-4-6.605-2.621-1.5-7.885-2.8-5.307,2.184.7,1.4,1.6,2.712,2.226,4.155.608,1.285.893,2.951,1.8,4,2.332,2.36,4.957-1.485,5.275-3.69Z",
    transform: "translate(-207.763 -380.729)",
    fill: "#b06d31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32040",
    "data-name": "Trac\\xE9 32040",
    d: "M371.059,360.237c.834-3.382-1.554-5.381-4.679-6.1-1.449-.436-3.867-.448-3.443,1.7a18.413,18.413,0,0,0,1.434,3.415,8.773,8.773,0,0,0,1.72,2.875c1.726,1.61,4.419.225,4.956-1.851Z",
    transform: "translate(-282.225 -275.239)",
    fill: "#b06d31"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32041",
    "data-name": "Trac\\xE9 32041",
    d: "M451.169,333.41a1.848,1.848,0,0,0,1.35-.668c1.343-1.372,1.452-4.15-.335-5.2a2.214,2.214,0,0,0-2.424.142c-.82.733-.59,1.948-.373,2.921.257.993.661,2.687,1.749,2.8Z",
    transform: "translate(-349.339 -254.508)",
    fill: "#b06d31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32042",
    "data-name": "Trac\\xE9 32042",
    d: "M379.662,249.274c2.308.3,4.954,1.5,5.422,4,.327,1.695-1.058,2.5-2.55,1.926-1.464-.516-5.061-2.858-5.548-4.272-.536-1.57,1.5-1.88,2.63-1.665Z",
    transform: "translate(-293.121 -193.813)",
    fill: "#b06d31"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32043",
    "data-name": "Trac\\xE9 32043",
    d: "M132.824,343.514c.871,1.986.7,4.944.1,7.1-1.5,5.31-5.961,4.464-9.138.976A7.3,7.3,0,0,1,121.621,348a6.265,6.265,0,0,1,2.092-5.455c2.711-2.5,7.49-2.874,9.094.935Z",
    transform: "translate(-94.533 -264.923)",
    fill: "#201810"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32044",
    "data-name": "Trac\\xE9 32044",
    d: "M292.422,213.1c2.117.577,3.3,3.157,3.366,5.225.068,1.86-1.356,4.4-3.392,4.131a5.152,5.152,0,0,1-2.708-2.035,14.937,14.937,0,0,0-2.1-2.052c-1.536-1.129-2.88-2.754-1.006-4.322a7.877,7.877,0,0,1,5.8-.958Z",
    transform: "translate(-222.167 -165.592)",
    fill: "#b06d31"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32045",
    "data-name": "Trac\\xE9 32045",
    d: "M166.412,243.3c1.96,1.977,2.656,5.89,1.822,8.595-.7,2.154-3.013,1.508-4.645.765a17.491,17.491,0,0,1-3.257-1.7,2.681,2.681,0,0,1-1.3-3.035,7.612,7.612,0,0,1,2.4-3.781c1.345-1.174,3.558-2.062,4.953-.861Z",
    transform: "translate(-123.603 -188.762)",
    fill: "#201810"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32046",
    "data-name": "Trac\\xE9 32046",
    d: "M379.289,251.639c2.419,2.522,1.945,4.945-1.774,5.289-1.387.144-3.2.327-4.243-.544-1.731-1.445-2.022-4.77,0-6.068,1.866-1.045,4.479-.189,5.98,1.289Z",
    transform: "translate(-289.206 -194.316)",
    fill: "#201810"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32047",
    "data-name": "Trac\\xE9 32047",
    d: "M443.506,329.6c1.358,2.191-.256,5.568-3.026,5.2-3.426-.235-3.546-4.5-.929-6.039a2.937,2.937,0,0,1,3.934.81Z",
    transform: "translate(-340.434 -255.352)",
    fill: "#201810"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32048",
    "data-name": "Trac\\xE9 32048",
    d: "M351.483,356.025c1.78,1.726,2.4,5.188.422,7.03a11.145,11.145,0,0,1-3.467,1.969c-3.293,1.379-6.118.33-6.435-3.542-.155-2.618.685-6.029,3.344-7.03a6.2,6.2,0,0,1,6.106,1.542Z",
    transform: "translate(-265.969 -275.451)",
    fill: "#201810"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32049",
    "data-name": "Trac\\xE9 32049",
    d: "M255.035,492.436c2.6,1.625,4.732,3.888,4.389,7.054-.393,3.69-4.867,4.723-8.069,4.552-3.715.114-5.611-3.387-5.559-6.725.014-2.281,1.06-5.049,3.191-6.031,1.824-.91,4.208-.058,6.006,1.122Z",
    transform: "translate(-191.159 -381.787)",
    fill: "#201810"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32050",
    "data-name": "Trac\\xE9 32050",
    d: "M282.661,217.828c1.834.178,3.7.665,4.71,2.16a4.5,4.5,0,0,1,.058,4.4,7.9,7.9,0,0,1-2.752,2.906c-1.7,1.127-3.633,1.986-5.43,1.193-2.244-1.086-2.991-3.951-2.635-6.268.583-3.286,2.6-4.788,6-4.4Z",
    transform: "translate(-215.061 -169.359)",
    fill: "#201810"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32051",
    "data-name": "Trac\\xE9 32051",
    d: "M141.574,472.518a3.5,3.5,0,0,1,3.663,3.562c-.019,3.717-.956,5.933-4.995,4.049-2.2-.969-3.564-3.612-2.134-5.745a4.2,4.2,0,0,1,3.419-1.865Z",
    transform: "translate(-106.952 -367.487)",
    fill: "#201810"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32052",
    "data-name": "Trac\\xE9 32052",
    d: "M238.023,386c1.87.876,2.993,2.48,2.385,4.467a3.119,3.119,0,0,1-5.155,1.654c-4.1-2.89-2.843-8.752,2.726-6.142Z",
    transform: "translate(-181.082 -299.677)",
    fill: "#201810"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32053",
    "data-name": "Trac\\xE9 32053",
    d: "M117.637,159.1a38.73,38.73,0,0,0-28.992,13.613c-.9,1.026-1.808,2.051-2.7,3.086-10.351,11.882-13.765,29.482-6.724,44.042a44.047,44.047,0,0,1,1.632,4.151c1.671,5.009,2.4,10.459,5.013,15.157a41.24,41.24,0,0,0,12.76,12.581c8.121,4.534,17.721,6.124,26.934,5.408,1.288-.1,2.622-.266,3.889-.465a3.646,3.646,0,0,0,2.286-1.231c1-1.136,1.275-3.066.534-3.7-.465-.4-1.18-.163-2.249.082-2.027.465-.054.076-5.44.671-3.059.338-6.443,1.6-9.481,1.058a13.1,13.1,0,0,1-1.959-.632c-4.285-1.683-10.4-4.991-14.114-6.728a12.036,12.036,0,0,1-3.442-2.289,65.234,65.234,0,0,1-4.239-5.007c-1.457-1.864-3.162-3.613-3.9-5.852-1.028-3.225-1.548-7.677-2.607-11.008-1.166-3.269-4.3-6.978-5.648-9.981-.815-1.62-.57-3.281-.14-5.031a26.373,26.373,0,0,0,.809-4.486,18.285,18.285,0,0,0-.435-3.2,13.514,13.514,0,0,1-.069-1.581,21.506,21.506,0,0,1,3.394-11.274,23.9,23.9,0,0,1,3.4-3.7,15.012,15.012,0,0,0,3.037-4.358,11.5,11.5,0,0,1,3.352-3.973,4.805,4.805,0,0,1,1.938-.6,5.981,5.981,0,0,0,2.632-1.022,23.576,23.576,0,0,0,2.645-2.353,16.26,16.26,0,0,1,5.057-3.337,18.662,18.662,0,0,1,3.348-.8c5.553-.929,10.915-2.234,16.329-2.1a41.3,41.3,0,0,1,11.412,1.072c4.945,1.459,3.93,5.019,7.817,6.62,1.583.758,3.531.867,5.2,1.35,2.717.8,4.13,3.563,5.919,5.548a65.81,65.81,0,0,0,6.688,6.883c1.036.927,2.444,2.078,3.286,2.927,1.828,1.636,1.918,4.213,1.016,6.363-.619,1.781-1.854,3.248-1.861,5.092a4.4,4.4,0,0,0,2.534,3.575,6.05,6.05,0,0,0,2.891.421c1.038-.1,1.774-.358,2.063-1.133.373-1.166-.129-3.1-.361-4.481-1.347-6.29-2.955-12.967-7.306-17.879-.52-.587-1.069-1.163-1.674-1.739a28.943,28.943,0,0,0-4.012-3.2c-3.415-2.307-6.771-8.16-7.329-9.049-2.28-3.635-9.858-7.319-33.128-7.518",
    transform: "translate(-58.732 -123.732)",
    fill: "#b06d31"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32054",
    "data-name": "Trac\\xE9 32054",
    d: "M204.88,437.838a13.4,13.4,0,0,0,1.849-7.844c-.121-1.135-.5-2.912.517-4,.541-.575,1.457-.935,1.76-.669.253.223.012.824-.311,1.83-.355,1.106-.553,2.258-.91,3.363-1.349,4.173-.291,5.962-1.985,8.528a8.087,8.087,0,0,1-2.114,2.152c-.181.061-.426.058-.429-.179a1.715,1.715,0,0,1,.425-.968,7.4,7.4,0,0,0,1.2-2.216",
    transform: "translate(-158.077 -330.717)",
    fill: "#b06d31"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32055",
    "data-name": "Trac\\xE9 32055",
    d: "M493.017,306.817c.1-.013.2.146.315.443.259.736.441,1.633.632,2.428.42,1.84.852,3.967,1.108,5.667.11,1.107.473,2.362.094,3.406a1.317,1.317,0,0,1-1.847.532,2.912,2.912,0,0,1-1.433-2.313,20.985,20.985,0,0,1,.377-6.844c.116-.728.224-1.483.351-2.2.082-.368.15-.977.394-1.112Z",
    transform: "translate(-382.423 -238.618)",
    fill: "#b06d31"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32056",
    "data-name": "Trac\\xE9 32056",
    d: "M336.984,297.63c1.386,1.2,3.1,2.128,3.872,3.858a27.1,27.1,0,0,1,.861,2.73c.231.609.424.35.689-.159a6.788,6.788,0,0,1,1.179-1.928c1.408-1.329,3.591-.31,5.358-.292.254-.006.8.018.748-.22a2.325,2.325,0,0,0-.651-.473c-.68-.4-1.425-1.13-2.118-1.522-1.692-.783-2.653,1.307-5.858-.374-1.493-.72-2.616-2.116-3.882-3.107-.56-.394-1.292-.784-1.38-.237a3.086,3.086,0,0,0,1.144,1.689Z",
    transform: "translate(-261.16 -229.923)",
    fill: "#b06d31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8168",
    "data-name": "Groupe 8168",
    transform: "translate(55.641 113.47)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8167",
    "data-name": "Groupe 8167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8166",
    "data-name": "Groupe 8166",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32057",
    "data-name": "Trac\\xE9 32057",
    d: "M251.006,516.693a3.6,3.6,0,0,0,2.465,1.877c.271.032.643-.014.7-.325a11.1,11.1,0,0,1-.811-1.434,14.1,14.1,0,0,1-.985-3.014c-.157-.7-.377-1.391-.506-2.1-.082-.452-.179-1.084-.545-1.194a.472.472,0,0,0-.286.012,7.172,7.172,0,0,0-.033,6.177",
    transform: "translate(-250.323 -510.487)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8171",
    "data-name": "Groupe 8171",
    transform: "translate(31.164 106.283)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8170",
    "data-name": "Groupe 8170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8169",
    "data-name": "Groupe 8169",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32058",
    "data-name": "Trac\\xE9 32058",
    d: "M140.451,481.244A3.368,3.368,0,0,0,142,482.962c.2.079.457.178.577-.018a.439.439,0,0,0-.007-.282c-.1-.392-.562-1.13-.812-1.833a15.987,15.987,0,0,1-.353-2.3c-.237-.945-.96.127-1.07.608a3.072,3.072,0,0,0,.094,2.059Z",
    transform: "translate(-140.202 -478.151)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8174",
    "data-name": "Groupe 8174",
    transform: "translate(29.137 81.653)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8173",
    "data-name": "Groupe 8173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8172",
    "data-name": "Groupe 8172",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32059",
    "data-name": "Trac\\xE9 32059",
    d: "M135.147,372.823c1.078.515.849-1.236.619-1.807a6.687,6.687,0,0,0-1.86-2.688,3.784,3.784,0,0,0-1.758-.954c-.763-.156-1.366.3-.9,1.1.54.918,1.706,1.737,2.369,2.646a7.547,7.547,0,0,0,1.5,1.683Z",
    transform: "translate(-131.085 -367.345)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8177",
    "data-name": "Groupe 8177",
    transform: "translate(53.105 87.42)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8176",
    "data-name": "Groupe 8176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8175",
    "data-name": "Groupe 8175",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32060",
    "data-name": "Trac\\xE9 32060",
    d: "M240.421,395.656c.227,0,.257-.259.243-.451a2.667,2.667,0,0,0-1.136-1.857.4.4,0,0,0-.59.193c-.211.723.81,1.961,1.456,2.115Z",
    transform: "translate(-238.91 -393.291)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8180",
    "data-name": "Groupe 8180",
    transform: "translate(78.682 85.921)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8179",
    "data-name": "Groupe 8179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8178",
    "data-name": "Groupe 8178",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32061",
    "data-name": "Trac\\xE9 32061",
    d: "M354.312,389.409c.854.417,2.288-.156,3.124-.7.607-.335,2.389-1.81.967-2.134-.925-.286-5.654,1.626-4.121,2.818Z",
    transform: "translate(-353.979 -386.547)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8183",
    "data-name": "Groupe 8183",
    transform: "translate(36.368 59.378)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8182",
    "data-name": "Groupe 8182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8181",
    "data-name": "Groupe 8181",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32062",
    "data-name": "Trac\\xE9 32062",
    d: "M165.243,269.9c.773.415,2.044,1.278,2.9.948.913-.867-2.577-3.74-3.5-3.7-1.08-.162-1.293.881-.7,1.644a4.34,4.34,0,0,0,1.254,1.077Z",
    transform: "translate(-163.614 -267.132)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8186",
    "data-name": "Groupe 8186",
    transform: "translate(62.456 51.23)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8185",
    "data-name": "Groupe 8185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8184",
    "data-name": "Groupe 8184",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32063",
    "data-name": "Trac\\xE9 32063",
    d: "M283.689,233.193a4.528,4.528,0,0,0,.889-2.255c-.243-1.134-1.679.109-2.058.59a6.768,6.768,0,0,0-1.447,2.752c-.174.583-.194,2.126.775,1.513a10.671,10.671,0,0,0,1.814-2.552Z",
    transform: "translate(-280.98 -230.475)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8189",
    "data-name": "Groupe 8189",
    transform: "translate(84.003 58.542)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8188",
    "data-name": "Groupe 8188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8187",
    "data-name": "Groupe 8187",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32064",
    "data-name": "Trac\\xE9 32064",
    d: "M379.259,264.5c.228-.65-.595-1.564-1.147-.9a1.118,1.118,0,0,0,.122,1.417c.386.3.9-.058,1.012-.476Z",
    transform: "translate(-377.917 -263.374)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8192",
    "data-name": "Groupe 8192",
    transform: "translate(98.925 77.348)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8191",
    "data-name": "Groupe 8191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8190",
    "data-name": "Groupe 8190",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32065",
    "data-name": "Trac\\xE9 32065",
    d: "M446.9,348.347a2.191,2.191,0,0,0-1.582-.343c-.3.066-.339.283-.14.51a1.742,1.742,0,0,0,.937.51c.514.15,1.284-.134.816-.649Z",
    transform: "translate(-445.052 -347.976)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8195",
    "data-name": "Groupe 8195",
    transform: "translate(52.949 118.538)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8194",
    "data-name": "Groupe 8194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8193",
    "data-name": "Groupe 8193",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32066",
    "data-name": "Trac\\xE9 32066",
    d: "M240.538,538.167a5.929,5.929,0,0,0,1.88,1.463c.486.244,1.443.326,1.118-.453-.332-.8-1.726-1.846-2.348-2.714-.661-.8-1.046-1.767-1.665-2.574-.288-.416-1.04-.986-1.277-.243-.313,1.567,1.3,3.339,2.255,4.482Z",
    transform: "translate(-238.208 -533.286)",
    fill: "#fff"
  }))))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32067",
    "data-name": "Trac\\xE9 32067",
    d: "M240.308,316.606c-.926-.168-2.319-.748-2.964-.85-.2-.036-.443-.048-.5.188a6.979,6.979,0,0,1-.453,2.369c-.4.856-1.281,1.872-1.552,2.486-.139.309-.15.473-.08.538.2.183,1.069-.369,1.649-.877,1.473-1.292,1.138-2.385,2.029-2.829,1.061-.529,1.687.947,4.18,1.189,1.952.189,2.061-.668,4.493-.483.533.04,1.3.14,1.636-.3a1.08,1.08,0,0,0,.009-1.2c-.569-.771-2.249-.021-4.811.08a14.676,14.676,0,0,1-3.635-.313",
    transform: "translate(-182.544 -245.555)",
    fill: "#b06d31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8198",
    "data-name": "Groupe 8198",
    transform: "translate(55.244 55.367)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8197",
    "data-name": "Groupe 8197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8196",
    "data-name": "Groupe 8196",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32068",
    "data-name": "Trac\\xE9 32068",
    d: "M249.608,259.675c.473,1.229,1.194,1.123,1.2-1.053a33.153,33.153,0,0,0-.589-5.3c-.325-2.038-.68-4.126-1.031-4.23-.567.046-.639,2.348-.652,3.747a20.985,20.985,0,0,0,1.026,6.729Z",
    transform: "translate(-248.536 -249.089)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8201",
    "data-name": "Groupe 8201",
    transform: "translate(27.242 93.238)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8200",
    "data-name": "Groupe 8200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8199",
    "data-name": "Groupe 8199",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32069",
    "data-name": "Trac\\xE9 32069",
    d: "M125.338,424.064c.731.777,3.154,2.277,3.847.908.248-1.183-1.6-2.292-2.424-3.049a15.238,15.238,0,0,0-2.821-2.286c-.691-.349-1.607-.211-1.335.762a5.957,5.957,0,0,0,1.179,1.909,18.215,18.215,0,0,0,1.517,1.722Z",
    transform: "translate(-122.556 -419.463)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8204",
    "data-name": "Groupe 8204",
    transform: "translate(42.547 103.378)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8203",
    "data-name": "Groupe 8203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8202",
    "data-name": "Groupe 8202",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32070",
    "data-name": "Trac\\xE9 32070",
    d: "M191.415,465.09a3.031,3.031,0,0,1,1.185.363,7.546,7.546,0,0,1,3.1,2.262c.822,1.08,1.115,2.474,1.884,3.582.778,1.174,2.171,1.918,2.814,3.146a6.627,6.627,0,0,1,.367,4.177c-.124.6-.284.623-.369.127-.338-3.055-.283-3.828-2.767-6.078a5.864,5.864,0,0,1-1.566-3.167c-.475-2.589-2.521-3.045-4.337-4.126-.113-.088-.284-.158-.309-.282Z",
    transform: "translate(-191.413 -465.082)",
    fill: "#b06d31"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8207",
    "data-name": "Groupe 8207",
    transform: "translate(61.668 80.138)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8206",
    "data-name": "Groupe 8206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8205",
    "data-name": "Groupe 8205",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32071",
    "data-name": "Trac\\xE9 32071",
    d: "M287.335,360.574c.495.07-.206.131-.463.155a11.3,11.3,0,0,0-2.042.323c-1.308.354-2.572,1.122-3.892,1.2a5.625,5.625,0,0,1-3.49-1.136c-.051-.069.05-.049.287.044,4.36,2,5.417-1.007,9.578-.59Z",
    transform: "translate(-277.434 -360.532)",
    fill: "#b06d31"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8210",
    "data-name": "Groupe 8210",
    transform: "translate(53.536 53.867)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8209",
    "data-name": "Groupe 8209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8208",
    "data-name": "Groupe 8208",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32072",
    "data-name": "Trac\\xE9 32072",
    d: "M245.683,242.339a3.058,3.058,0,0,1,.295,1.1,14.439,14.439,0,0,1-.541,5.494,26.03,26.03,0,0,1-.676,2.848A13.9,13.9,0,0,1,242.4,255.3c-.423.579-.826,1.271-1.115,1.676-.513.725-.552.4-.2-.361.761-1.742,2.4-3.321,3.1-5.088a17.855,17.855,0,0,0,.741-3.384,25.285,25.285,0,0,0,.727-3.935c.055-.506-.072-1.484.035-1.863Z",
    transform: "translate(-240.85 -242.339)",
    fill: "#b06d31"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8213",
    "data-name": "Groupe 8213",
    transform: "translate(59.04 60.257)",
    opacity: 0.1,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8212",
    "data-name": "Groupe 8212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8211",
    "data-name": "Groupe 8211",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32073",
    "data-name": "Trac\\xE9 32073",
    d: "M267.032,271.087a3.7,3.7,0,0,1,3.049,1.765c.029.5-1.646-.542-2.3-.644-.617-.183-1.293-.152-1.9-.309-.91-.341.7-.856,1.092-.81Z",
    transform: "translate(-265.614 -271.086)",
    fill: "#b06d31"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8216",
    "data-name": "Groupe 8216",
    transform: "translate(70.199 92.017)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8215",
    "data-name": "Groupe 8215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8214",
    "data-name": "Groupe 8214",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32074",
    "data-name": "Trac\\xE9 32074",
    d: "M317.648,441.3c.548-2.912-.036-5.731.017-8.8.04-3.724,1.26-8.043,3.449-10.753,1.489-1.906,3.62-2.941,5.562-4.5,1.074-.845,2.1-1.952,3.075-2.853.255-.236.83-.707.79-.156-.184,1.357-2.165,3.841-3.4,5.042-3.342,3.178-5.393,6.232-6.337,10.81-.736,3.275-.6,6.726-1.366,9.954a26.783,26.783,0,0,1-1.99,5.511c-.267.551-.531,1.053-.762,1.459-.4.66-.632,1.1-.839,1.068a5.85,5.85,0,0,1,.54-2.338,31.3,31.3,0,0,0,1.249-4.391Z",
    transform: "translate(-315.815 -413.974)",
    fill: "#fff"
  }))))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32075",
    "data-name": "Trac\\xE9 32075",
    d: "M456.674,456.269c-.088,1.987-2.471,3.2-4.1,4.207-1.433.859-3.025,1.711-4.713,1.207a8.58,8.58,0,0,1-4.829-4.422,5.344,5.344,0,0,1,.327-4.7c1.081-1.952,2.879-4,4.973-3.887,1.552.177,2.708,1.339,3.917,2.274,1.619,1.424,4.438,2.919,4.423,5.287Z",
    transform: "translate(-344.245 -348.938)",
    fill: "#fb9f3b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32076",
    "data-name": "Trac\\xE9 32076",
    d: "M477.775,456.389c-.057,1.421-1.271,2.441-2.386,3.188-.8.5-5.283,3.5-5.1,1.8.98-3.072,3.523-4.537,1.246-8.033-.715-1.212-1.825-2.53-2.028-3.915-.056-.388.077-.774.509-.689a2.027,2.027,0,0,1,.648.277c.782.473,1.976,1.5,3.16,2.4,1.6,1.268,3.964,2.673,3.957,4.932Z",
    transform: "translate(-365.134 -348.988)",
    fill: "#b06d31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8219",
    "data-name": "Groupe 8219",
    transform: "translate(99.693 103.71)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8218",
    "data-name": "Groupe 8218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8217",
    "data-name": "Groupe 8217",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32077",
    "data-name": "Trac\\xE9 32077",
    d: "M448.634,469.794c.141.806,1.292,2.768,2.115,1.926.711-1.15.268-4.325-.954-5.071a.62.62,0,0,0-.837.283,3.869,3.869,0,0,0-.339,2.8Z",
    transform: "translate(-448.505 -466.578)",
    fill: "#fff"
  }))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32078",
    "data-name": "Trac\\xE9 32078",
    d: "M395.386,485.285a1.441,1.441,0,0,0,.64-1.066,1.982,1.982,0,0,0-.477-1.043,7.693,7.693,0,0,1-.524-.876,8.444,8.444,0,0,1-.771-2.185c-.146-.71.08-2.116-.551-2.623a.1.1,0,0,0-.023-.017c-.614-.431-3.607-.445-4.487-.543-4.162-.465-4.358,4.529-3.5,7.585a2.268,2.268,0,0,0,.371.826,1.022,1.022,0,0,0,.268.243c.591.365,1.259-.021,1.94-.306a3.513,3.513,0,0,1,.682-.22c1.07-.194,2.052.574,3.1.881a3.768,3.768,0,0,0,3.336-.655",
    transform: "translate(-299.642 -370.896)",
    fill: "#fb9f3b"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32079",
    "data-name": "Trac\\xE9 32079",
    d: "M398.117,487.289a1.441,1.441,0,0,0,.64-1.066,1.983,1.983,0,0,0-.477-1.043,8.406,8.406,0,0,1-1.294-3.062c-.146-.71.08-2.116-.551-2.623a.1.1,0,0,0-.023-.017,3.3,3.3,0,0,0-.855,1.185,5.517,5.517,0,0,0,.082,2.593,2.244,2.244,0,0,1-.792,2.333,2.144,2.144,0,0,1-1.068.2,6.289,6.289,0,0,1-1.417-.194,2.431,2.431,0,0,0-1.189-.137,1.893,1.893,0,0,0-.819.557,7.606,7.606,0,0,1-1.558,1.332,1.022,1.022,0,0,0,.268.243c.788.486,1.712-.359,2.623-.526,1.07-.194,2.052.574,3.1.881a3.768,3.768,0,0,0,3.336-.655",
    transform: "translate(-302.373 -372.9)",
    fill: "#b06d31"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32080",
    "data-name": "Trac\\xE9 32080",
    d: "M420.011,489.371a2.263,2.263,0,0,1-.176-.859.9.9,0,0,1,.438-.66,5.07,5.07,0,0,0,.064.778,8.445,8.445,0,0,0,.771,2.185,7.666,7.666,0,0,0,.524.876,1.984,1.984,0,0,1,.477,1.043,1.441,1.441,0,0,1-.64,1.066,3.776,3.776,0,0,1-2.649.782,4.357,4.357,0,0,0,.726-1.171,5.837,5.837,0,0,0,.465-4.041",
    transform: "translate(-325.725 -379.414)",
    fill: "#b06d31"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32081",
    "data-name": "Trac\\xE9 32081",
    d: "M459.419,400.746a.971.971,0,0,0,.337.767,1.337,1.337,0,0,0,.759.144,5.141,5.141,0,0,1,.686.054,5.691,5.691,0,0,1,1.5.428c.447.2,1.131.869,1.656.719l.018-.006c.476-.17,1.65-1.808,2.047-2.254,1.877-2.105-.79-4.159-2.8-4.879a1.537,1.537,0,0,0-.6-.118.686.686,0,0,0-.238.053c-.431.182-.479.7-.588,1.185a2.377,2.377,0,0,1-.145.46c-.311.664-1.115.9-1.69,1.357a2.538,2.538,0,0,0-.94,2.088",
    transform: "translate(-357.297 -307.667)",
    fill: "#fb9f3b"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32082",
    "data-name": "Trac\\xE9 32082",
    d: "M459.419,400.752a.971.971,0,0,0,.337.767,1.338,1.338,0,0,0,.759.144,5.659,5.659,0,0,1,2.187.482c.447.2,1.131.869,1.656.719l.018-.006a2.221,2.221,0,0,0-.317-.931,3.718,3.718,0,0,0-1.457-.965c-.521-.276-1.044-.76-.973-1.344a1.443,1.443,0,0,1,.307-.664,4.227,4.227,0,0,1,.659-.7,1.639,1.639,0,0,0,.539-.6,1.273,1.273,0,0,0,.013-.667,5.135,5.135,0,0,1-.125-1.375.687.687,0,0,0-.238.053c-.574.243-.47,1.081-.733,1.646-.311.664-1.115.9-1.69,1.357a2.538,2.538,0,0,0-.94,2.088",
    transform: "translate(-357.297 -307.673)",
    fill: "#b06d31"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32083",
    "data-name": "Trac\\xE9 32083",
    d: "M462.422,413.518a1.527,1.527,0,0,1,.54.238.6.6,0,0,1,.192.5,3.4,3.4,0,0,0-.452-.268,5.684,5.684,0,0,0-1.5-.428,5.217,5.217,0,0,0-.685-.054,1.333,1.333,0,0,1-.759-.144.97.97,0,0,1-.337-.767,2.544,2.544,0,0,1,.6-1.76,2.936,2.936,0,0,0,.361.855,3.93,3.93,0,0,0,2.039,1.83",
    transform: "translate(-357.298 -319.514)",
    fill: "#b06d31"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32084",
    "data-name": "Trac\\xE9 32084",
    d: "M400.166,562.086a3.923,3.923,0,0,0,1.907-1.794c.517-1.073.164-2.359-.543-4.93-.286-1.04-.443-1.337-.747-1.539-.575-.381-1.159-.077-2.792-.242-.416-.042-.7-.094-1.143-.176-2.878-.529-3.911-1.828-5.025-1.379-.526.212-.866.636-1.175,1.606-1.346,4.225-1.265,7.083,3.5,7.946a26.8,26.8,0,0,0,3,.42,29.844,29.844,0,0,0,3.018.087",
    transform: "translate(-303.232 -429.25)",
    fill: "#fb9f3b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32085",
    "data-name": "Trac\\xE9 32085",
    d: "M398.584,551.782c.152,1.1,2.143,2.054,3.092,2.53,3.348,1.484,5.476,1.7,6.989,5.4.456.929.407-.287.431-1.051-.1-1.99.161-4.866-1.949-5.937-1.085-.536-2.632-.393-3.941-.493a12.95,12.95,0,0,1-2.217-.346c-.549-.08-2.192-.67-2.4-.112Z",
    transform: "translate(-309.987 -428.937)",
    fill: "#b06d31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8222",
    "data-name": "Groupe 8222",
    transform: "translate(88.041 126.023)",
    opacity: 0.25,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8221",
    "data-name": "Groupe 8221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8220",
    "data-name": "Groupe 8220",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32086",
    "data-name": "Trac\\xE9 32086",
    d: "M396.757,571.263c1.452.61,1.112-3.785.549-4.188-.685-.591-1.147,1.213-1.182,1.722a2.882,2.882,0,0,0,.609,2.449Z",
    transform: "translate(-396.086 -566.958)",
    fill: "#fff"
  }))))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32087",
    "data-name": "Trac\\xE9 32087",
    d: "M490.247,530.669a2.521,2.521,0,0,0,2.345.469c.4-.193.806-.653,1.327-.561a.72.72,0,0,0,.414,0,.916.916,0,0,0,.438-.466,5.549,5.549,0,0,0,.5-4.468,3.483,3.483,0,0,0-3.4-2.286,2.406,2.406,0,0,0-1.107.54,4.883,4.883,0,0,0-1.574,3.958,3.494,3.494,0,0,0,1.055,2.814",
    transform: "translate(-380.451 -407.006)",
    fill: "#fb9f3b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32088",
    "data-name": "Trac\\xE9 32088",
    d: "M496.288,523.873a.354.354,0,0,0,.106.112c.146.086.326.02.492.029a1.109,1.109,0,0,1,.591.307l1.617,1.31a1.334,1.334,0,0,1,.419.47c.208.472-.126,1.058.05,1.545.068.19.207.34.293.521.33.7-.235,1.521-.207,2.31,0,.036.01.069.014.1.326,0,.493-.248.629-.494a5.551,5.551,0,0,0,.5-4.469,3.288,3.288,0,0,0-3.4-2.286,2.329,2.329,0,0,0-1.107.54",
    transform: "translate(-385.974 -406.981)",
    fill: "#b06d31"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8229",
    "data-name": "Groupe 8229",
    transform: "translate(16.786 35.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8228",
    "data-name": "Groupe 8228",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8227",
    "data-name": "Groupe 8227",
    transform: "translate(-6.461 -12.589)",
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8226",
    "data-name": "Groupe 8226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8225",
    "data-name": "Groupe 8225",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32089",
    "data-name": "Trac\\xE9 32089",
    d: "M47.241,173.648a217.779,217.779,0,0,0,67.67,5.087,222.208,222.208,0,0,0,60.011-13.556L158.83,102.444,46.45,112.32Z",
    transform: "translate(-46.45 -102.444)"
  }))))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8231",
    "data-name": "Groupe 8231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8230",
    "data-name": "Groupe 8230",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32091",
    "data-name": "Trac\\xE9 32091",
    d: "M120.7,212.53c.14,10-32.655,22.414-54.929,21.034C46.779,233.521-.7,226.7.008,210.591c4.308-22.73,122.406-18,120.69,1.939",
    transform: "translate(0 -152.016)",
    fill: "#2c2928",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32092",
    "data-name": "Trac\\xE9 32092",
    d: "M120.7,262.983c.14,10-32.655,22.414-54.929,21.034C46.779,283.974-.7,277.154.008,261.044c.024-.131.074-.26.107-.394.088-.2.144-.319.144-.313,19.694,23.139,101.794,27.367,120.27.889a4.934,4.934,0,0,1,.169,1.757",
    transform: "translate(0 -202.47)",
    fill: "#625a56",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32093",
    "data-name": "Trac\\xE9 32093",
    d: "M181.729,68.651c-7.827,8.06-46.241,12.54-71.632-.556,1.668-9.269,2.862-16.852,3.652-22.13,1.478-9.874,1.7-12.716,4.161-15.167,4.295-4.276,12.161-4.125,17.6-1.651,5.2,2.366,6.416,6.055,9.656,5.372,3.378-.712,3.7-5.069,7.97-8.068a14.41,14.41,0,0,1,10.5-2.063c8.893-.59,16.467,33,18.092,44.262",
    transform: "translate(-85.625 -18.804)",
    fill: "#625b57",
    fillRule: "evenodd"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8233",
    "data-name": "Groupe 8233",
    transform: "translate(24.472 5.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8232",
    "data-name": "Groupe 8232",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32094",
    "data-name": "Trac\\xE9 32094",
    d: "M200.177,2.834c2.639,3.019,14.576,14.037,16.428,15.459,3.727,2.87,6.341,3.275,12.629-2.378,2.247-2.019,6.978-13.282,3.787-15.809h-.056a15.516,15.516,0,0,0-4.206.082,30.189,30.189,0,0,1-3.858.994c-4.216,1.488-8.086,4.072-11.532,5.792-4.226.663-8.811-2.557-13.193-4.14",
    transform: "translate(-180.154 -5.374)",
    fill: "#9d9996",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32095",
    "data-name": "Trac\\xE9 32095",
    d: "M349.466,35.209c-3.386,5.3-6.5,12.987-2.33,18.73,5.982,8.239,11.425,14.338,20.145,9.807-1.806-10.55-6.826-31.672-13.069-39.094-.014.014-.026.023-.04.037-3.409,3.219-1.355,5.277-4.705,10.52",
    transform: "translate(-292.889 -24.548)",
    fill: "#2c2928",
    fillRule: "evenodd"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8235",
    "data-name": "Groupe 8235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8234",
    "data-name": "Groupe 8234",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32097",
    "data-name": "Trac\\xE9 32097",
    d: "M147.727,71.366c1.006,2.136.574,3.249.306,10.818-.355,10.053.273,11.849-1.444,14.425-1.783,2.675-4.738,4.166-6.744,4.148-4.174-.037-7.827-6.481-8.739-11.82-1.547-9.06,4.807-14.9,7.934-23.428.05-.137,3.915-4.277,8.686,5.857",
    transform: "translate(-101.779 -50.208)",
    fill: "#2c2928",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_32098",
    "data-name": "Trac\\xE9 32098",
    d: "M101.169,234.382q.952-6.7,1.906-13.4c9.437,6.245,56.747,11.725,71.675.724l2.375,14c-7.208,7.429-63.639,13.044-75.956-1.319",
    transform: "translate(-78.681 -171.862)",
    fill: "#131312",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookiesModalCover);
export default __webpack_public_path__ + "static/media/cookies-modal-cover.df9053e52f2a921848d3965beb87a424.svg";
export { ForwardRef as ReactComponent };